/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

/* eslint-disable import/export */
/* eslint-disable import/no-cycle */

import * as constantsFromComponents from '@veeam/components/lib/helpers/constants';

import * as constantsExtended from '../constants';

// reexport all components from uikit
export * from '@veeam/components';
export { Checkbox as CheckboxKit } from '@veeam/components';
export { Grid as GridKit, Pagination as PaginationKit } from '@veeam/components';
export { Combobox as ComboboxKit } from '@veeam/components';
export { FileInput as FileInputKit } from '@veeam/components';
export { NumberInput as NumberInputKit } from '@veeam/components';
export { PageWizardStep as PageWizardStepKit } from '@veeam/components';
export { PasswordInput as PasswordInputKit } from '@veeam/components';
export { Radiobutton as RadiobuttonKit } from '@veeam/components';
export { TextareaInput as TextareaKit } from '@veeam/components';
export { TextInput as TextInputKit } from '@veeam/components';
export { Toggle as ToggleKit } from '@veeam/components';
export { Search as SearchKit } from '@veeam/components';
export { SelectLink as SelectLinkKit } from '@veeam/components';
export { LinkButton as LinkButtonKit } from '@veeam/components';
export { ThemeProvider as ThemeProviderKit } from '@veeam/components';
export { colors } from '@veeam/components/lib/themes/colors/colors';
export {
    GRID_EXPAND_COLLAPSE_PLUGIN_COLUMN_TYPE,
} from '@veeam/components/lib/GridCore/plugins/expandCollapse/types/GridExpandCollapsePluginColumnType';
export const constants = {
    ...constantsFromComponents,
    ...constantsExtended,
};
export * as themes from '@veeam/components/lib/themes';
export { APP_LAYOUT_ALIGN } from '@veeam/components';
export type { WizardSummaryProps } from '@veeam/components/lib/WizardSummary';

// define our overrides
export { AdvancedFilter } from '../AdvancedFilter';
export { AdvancedFilter as AdvancedFilterKit } from '@veeam/components';
export type { AdvancedFilterValue } from '../AdvancedFilter';
export { BasicFilter, PoweredBasicFilter } from '../BasicFilter';
export type { BasicFilterProps, ToggleButtonProps, ToggleButtonWithTextProps, ToggleButtonWithIconProps } from '../BasicFilter';
export { NoteBar } from '../NoteBar';
export type { NoteBarProps } from '../NoteBar';
export { NoteBar as NoteBarKit } from '@veeam/components';
export type { NoteBarProps as NoteBarKitProps } from '@veeam/components';

export { DatePeriod } from '../DatePeriod';
export type { DatePeriodProps } from '../DatePeriod';
export { DatePeriod as DatePeriodKit } from '@veeam/components';
export type { DatePeriodProps as DatePeriodPropsKit } from '@veeam/components';
export { DatetimeInput } from '../DatetimeInput';
export { DatetimeInput as DatetimeKit } from '@veeam/components';

// export * from './FullPageButton';
// export * from './GettingStartedList';
export * from '../Grid';
export type { GridColumnProps, GridProps, GridColumn } from '../Grid/interfaces';
export { Grid, refreshNotificationRenderer, Pagination, useContextMenu } from '../Grid';
export type { NotificationProps } from '../Grid';

export { Search } from '../Search';
export type { SearchProps } from '../Search';
export { Toolbar } from '../Toolbar';
export { Toolbar as ToolbarKit } from '@veeam/components';
export type { ToolbarItem } from '../Toolbar/interfaces';
export * from '../Toolbar/interfaces';

export type { ToolbarItems, GroupToolbarItems } from '@veeam/components/lib/Toolbar/types';
export * from '@veeam/components/lib/Toolbar/types';
export type { DecoratorFunction } from '@veeam/components/lib/Toolbar/helpers/toolbarItemDecorators';
export * from '../form';
export {
    Form,
    TextInput,
    Combobox,
    Textarea,
    Datetime,
    Radiobutton,
    NumberInput,
    Checkbox,
    Toggle,
    PasswordInput,
    FileInput,
    WizardPanelSelector,
    defaultMaskPlaceholder,
} from '../form/components';
export type {
    CheckboxProps,
    ComboboxProps,
    FileInputProps,
    NumberInputProps,
    PasswordInputProps,
    RadiobuttonProps,
    TextInputProps,
    ToggleProps,
} from '../form/components';
export type { WizardPanelSelectorProps } from '../form/components';
export { DataList, SELECTION_MODE } from '../DataList';
export { StyledList } from '../StyledList';
export type { ListClickEventProps } from '../DataList';
export type { OrderedListProps } from '../OrderedList';
export { OrderedList, ListItem } from '../OrderedList';
export { SelectLink } from '../SelectLink';
export { LinkButton } from '../LinkButton';

// define our additional components
// export { FeatureToggle } from './FeatureToggle';
// export * from './FieldsetBlocks';
// export * from './PageDialog';
export * from '../PageWizard';
// export * from './ParsedText';
// export * from './PluginEntry';
// export * from './CopyToClipboardButton';
// export * from './PortalSpinner';
// export * from './NotificationDialogs';
// export * from './LoginForms';
// export * from './layouts';
export { ThemeProvider } from '../providers/ThemeProvider';
export type { ThemeProviderProps } from '../providers/ThemeProvider';
export { Guard } from '../guard';
// export * from './ToolbarWithExport';
// export * from './StatusToggleFilter';

export type { OffsetPosition } from '../ContextMenu';
export * from '../DialogWizard';
export type { PageWizardStep } from '../PageWizard';
export type { WizardProps } from '../DialogWizard';
